import { Component, createEffect, createSignal, on, onMount } from 'solid-js'
import { TTSService } from '/common/types'
import Select, { Option } from '/web/shared/Select'
import { voiceStore } from '/web/store/voice'
import { isHuanYouAISpeechAllowed } from '/web/shared/Audio/speech'
import { i18nStore } from '/web/store'

export const VoiceServiceSelect: Component<{
  value: TTSService | undefined
  onChange: (service: TTSService) => void
}> = (props) => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const services = voiceStore((s) => s.services)
  const [options, setOptions] = createSignal<Option<TTSService | ''>[]>([])

  onMount(() => {
    voiceStore.getServices()
  })

  // Update services list
  createEffect(
    on(
      () => services,
      (services) => {
        const canUseAgnai = isHuanYouAISpeechAllowed()

        const values: Option<TTSService | ''>[] = [{ value: '', label: i18n.t.chat_none }]

        if (canUseAgnai) {
          values.push({ label: i18n.t.settings_voice_agnaistic, value: 'agnaistic' })
        }

        for (const svc of services) {
          values.push({ label: svc.label, value: svc.type })
        }
        const current = props.value
        if (current && !values.find((v) => v.value === current)) {
          values.push({ value: current, label: current })
        }
        setOptions(values)
      }
    )
  )

  return (
    <>
      <Select
        fieldName="ttsService"
        items={options()}
        value={props.value}
        label={i18n.t.char_voiceService}
        onChange={(ev) => props.onChange((ev.value as TTSService) || '' || undefined)}
      ></Select>
    </>
  )
}
